import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
export default function getNotificationSettingsUrl(projectId) {
  return "".concat(getAccHostname(), "/settings/projects/").concat(projectId, "/notifications?previousPage=").concat(encodeURIComponent(window.location.href));
}
//# sourceMappingURL=getNotificationSettingsUrl.js.map